module.exports = __webpack_public_path__ + "static/media/icon-download-blue.8ea10cd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/icon-download-blue.svg
// module id = 347
// module chunks = 0